import { useContext } from 'react';
import { useFormatter } from '@izettle/react';
import { TranslatorContext } from '../providers/translations.js';

// Using this value as a memo that works cross components
let useLocalizationReturn = null;
const useLocalization = () => {
  const {
    translator,
    text
  } = useContext(TranslatorContext);
  const formatters = useFormatter();

  // (Probably unnecessary) production optimization
  // Re-use same formatters, translator, text functions between components
  // In development environments (not production) we always create new ones in case we switch locales
  if (process.env.JEST_WORKER_ID == null && process.env.APP_ENV === "production" && useLocalizationReturn) {
    return useLocalizationReturn;
  }
  useLocalizationReturn = {
    ...formatters,
    translator,
    isoLocale: translator.locale,
    text
  };
  return useLocalizationReturn;
};

export { useLocalization };
//# sourceMappingURL=use-localization.js.map
